// safe-mode.component.ts
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-safe-mode',
  template: `
    <div class="safe-mode-container">
      <div class="safe-mode-content">
        <h1>Modo de Segurança</h1>
        <p class="explanation">
          O aplicativo encontrou problemas persistentes e entrou em modo de
          segurança.
        </p>

        <div class="actions">
          <button
            pButton
            label="Limpar Dados e Reiniciar"
            icon="pi pi-refresh"
            (click)="resetApplication()"
          ></button>

          <button
            pButton
            label="Continuar em Modo Seguro"
            icon="pi pi-arrow-right"
            class="p-button-outlined"
            (click)="continueInSafeMode()"
          ></button>
        </div>

        <div class="support-info">
          <p>
            Se o problema persistir, entre em contato com o suporte técnico.
          </p>
          <small>ID de Sessão: {{ sessionId }}</small>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .safe-mode-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        background-color: #f5f5f5;
        padding: 20px;
      }

      .safe-mode-content {
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        padding: 2rem;
        max-width: 600px;
        width: 100%;
        text-align: center;
      }

      h1 {
        color: #ff9800;
        margin-bottom: 1rem;
      }

      .explanation {
        margin-bottom: 2rem;
        font-size: 1.1rem;
        line-height: 1.5;
      }

      .actions {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        margin-bottom: 2rem;
      }

      .support-info {
        border-top: 1px solid #eee;
        padding-top: 1rem;
        font-size: 0.9rem;
        color: #666;
      }

      small {
        display: block;
        margin-top: 0.5rem;
        font-size: 0.8rem;
        color: #999;
      }

      @media (min-width: 768px) {
        .actions {
          flex-direction: row;
          justify-content: center;
        }
      }
    `
  ]
})
export class SafeModeComponent implements OnInit {
  sessionId: string = '';

  constructor() {}

  ngOnInit(): void {
    this.sessionId = this.generateSessionId();
  }

  resetApplication(): void {
    // Limpar todos os dados
    localStorage.clear();
    sessionStorage.clear();

    // Limpar todos os caches
    if (window.caches) {
      caches.keys().then(keys => {
        keys.forEach(key => caches.delete(key));
      });
    }

    // Recarregar a aplicação
    window.location.href = '/';
  }

  continueInSafeMode(): void {
    // Configurar flag de modo seguro
    localStorage.setItem('safe-mode', 'true');

    // Redirecionar para a página inicial
    window.location.href = '/?safe=true';
  }

  private generateSessionId(): string {
    // Gera um ID de sessão para ajudar no suporte
    return (
      Date.now().toString(36) +
      Math.random()
        .toString(36)
        .substr(2, 5)
        .toUpperCase()
    );
  }
}
